/*
This file is generated by npm script 'extract-sass-vars' using the contents of variables.scss.

It needs to be checked in and can be edited, but 'npm run extract-sass-vars' will overwrite it
with whatever is in variables.scss, so changes should be made there instead.

After any edits to variables.scss, always run 'npm run extract-sass-vars' to regenerate this file.

This object is used to support any React components created using the styled-components library.
The library provides a ThemeProvider wrapper component that puts this object into its React context,
exposing it to components using styled-components as a property called "theme". The ThemeProvider
is used in App.jsx. See: https://www.styled-components.com/docs/advanced#theming

If we decide to move away from styled-components, then we won't need this file, and ThemeProvider
can be removed from App.jsx.
*/

const variables = {
  heavyFontFamily:
   'Brandon Grotesque Bold',
  mediumFontFamily:
   'Brandon Grotesque Medium',
  regularFontFamily:
   'Brandon Grotesque Regular',
  atlasboardFontFamily:
   'Roboto',
  fixedFontFamily:
   'Inconsolata',
  alternateFixedFontFamily:
   'Anonymous Pro',
  fontFamily:
   'Brandon Grotesque Bold',
  minWidth:
   '1280px',
  minHeight:
   '720px',
  gutterSize:
   '10px',
  bodyPadding: 0,
  brandPrimary:
   'rgb(70, 130, 180)',
  brandInfo:
   'rgb(18, 176, 197)',
  brandSuccess:
   'rgb(82, 165, 82)',
  brandWarning:
   'rgb(213, 180, 65)',
  brandError:
   'rgb(216, 155, 70)',
  brandDanger:
   'rgb(249, 67, 63)',
  slingBlue:
   'rgb(97, 169, 220)',
  slingOrange:
   'rgb(229, 161, 50)',
  slingBluer:
   'rgb(20, 171, 224)',
  slingOrangeDark:
   'rgb(157, 105, 20)',
  slingBlueDark:
   'rgb(39, 119, 176)',
  brandPrimaryLight:
   'rgb(215, 228, 239)',
  brandInfoLight:
   'rgb(172, 238, 247)',
  brandSuccessLight:
   'rgb(216, 235, 216)',
  brandWarningLight:
   'rgb(250, 246, 232)',
  brandErrorLight:
   'rgb(252, 246, 238)',
  brandDangerLight:
   'rgb(255, 255, 255)',
  brandPrimaryLighter:
   'rgb(255, 255, 255)',
  brandInfoLighter:
   'rgb(255, 255, 255)',
  brandSuccessLighter:
   'rgb(255, 255, 255)',
  brandWarningLighter:
   'rgb(255, 255, 255)',
  brandErrorLighter:
   'rgb(255, 255, 255)',
  brandDangerLighter:
   'rgb(255, 255, 255)',
  brandPrimaryDark:
   'rgb(41, 77, 107)',
  brandInfoDark:
   'rgb(9, 93, 104)',
  brandSuccessDark:
   'rgb(48, 97, 48)',
  brandWarningDark:
   'rgb(144, 119, 32)',
  brandErrorDark:
   'rgb(152, 102, 32)',
  brandDangerDark:
   'rgb(204, 11, 6)',
  brandPrimaryDarker:
   'rgb(13, 24, 33)',
  brandInfoDarker:
   'rgb(1, 9, 10)',
  brandSuccessDarker:
   'rgb(14, 29, 14)',
  brandWarningDarker:
   'rgb(61, 50, 13)',
  brandErrorDarker:
   'rgb(68, 45, 14)',
  brandDangerDarker:
   'rgb(105, 5, 3)',
  successColor:
   'rgb(82, 165, 82)',
  infoColor:
   'rgb(18, 176, 197)',
  warningColor:
   'rgb(213, 180, 65)',
  errorColor:
   'rgb(216, 155, 70)',
  dangerColor:
   'rgb(249, 67, 63)',
  grayBase:
   'rgb(24, 24, 24)',
  grayDarker:
   'rgb(32, 32, 32)',
  grayDark:
   'rgb(88, 88, 88)',
  gray:
   'rgb(112, 112, 112)',
  grayLight:
   'rgb(189, 188, 188)',
  grayLighter:
   'rgb(203, 202, 202)',
  grayLighterStill:
   'rgb(241, 241, 241)',
  grayLightest:
   'rgb(247, 247, 247)',
  backgroundColor:
   'rgb(32, 32, 32)',
  backgroundImage:
   'none',
  dashboardTitleColor:
   'rgb(112, 112, 112)',
  dashboardTitleFontSize:
   '1.7em',
  pdfThemeBackground:
   'rgb(255, 255, 255)',
  pdfThemeForeground:
   'rgb(0, 0, 0)',
};

export default variables;
